exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cf-container[data-v-1d8c2a82] {\n  min-height: 200px;\n}\n.stopbar-loader[data-v-1d8c2a82] {\n  min-height: 400px;\n  position: absolute;\n  top: 40%;\n  left: 50%;\n}\n.stopbar-loader span[data-v-1d8c2a82] {\n    position: absolute;\n    margin-top: 50px;\n    width: 110px;\n    left: calc((100% - 100px) / 2);\n    text-align: center;\n    font-weight: 600;\n}\n", ""]);

// exports
